export default __webpack_public_path__ + "f2fad968f92a3d8199f6a3d43987d731.png";